import { Notifier } from "@airbrake/browser";
import { useMemo, type PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallbackReload } from "../ErrorBoundaryFallbackReload/ErrorBoundaryFallbackReload";

type ErrorBoundaryAirbrakeProps = {
  projectId?: string;
  projectKey?: string;
};

export function ErrorBoundaryAirbrake({
  projectId,
  projectKey,
  children,
}: PropsWithChildren<ErrorBoundaryAirbrakeProps>) {
  const notifier = useMemo<Notifier | undefined>(() => {
    if (projectId && projectKey) {
      const projectIdNumber = Number(projectId);

      if (Number.isFinite(projectIdNumber)) {
        return new Notifier({
          projectId: projectIdNumber,
          projectKey,
        });
      }
    }

    return undefined;
  }, [projectId, projectKey]);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryFallbackReload}
      onError={(error, info) => {
        notifier?.notify({
          error: error,
          params: { info },
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
